import type { Socket } from "socket.io-client";
import type { BoardTaskDelta, StoryEntryDelta } from "@bash/shared";
import { EVENTS } from "@/constants/events";
import { useHistoryStore } from "../historyStore";

/**
 * home-streams: board deltas → history store. The board's push lane; the
 * reconcile reads in SocketBridge/HomeBriefing remain the truth path.
 */
export function registerBoardHandlers(socket: Socket): () => void {
  const handleBoardDelta = (delta: BoardTaskDelta) => {
    useHistoryStore.getState().applyBoardDelta(delta);
  };
  const handleStoryEntry = (delta: StoryEntryDelta) => {
    useHistoryStore.getState().applyStoryEntry(delta);
  };

  socket.on(EVENTS.BOARD_TASK_DELTA, handleBoardDelta);
  socket.on(EVENTS.STORY_ENTRY, handleStoryEntry);

  return () => {
    socket.off(EVENTS.BOARD_TASK_DELTA, handleBoardDelta);
    socket.off(EVENTS.STORY_ENTRY, handleStoryEntry);
  };
}
